import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { LayoutGroup } from "motion/react";
export const CollectionHeaderLayoutGroupFragment = graphql(`
  fragment CollectionHeaderLayoutGroup on Collection {
    slug
  }
`);
export function CollectionHeaderLayoutGroup(t0) {
  const $ = _c(6);
  let collection;
  let props;
  if ($[0] !== t0) {
    ({
      collection,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = collection;
    $[2] = props;
  } else {
    collection = $[1];
    props = $[2];
  }
  const {
    slug
  } = readFragment(CollectionHeaderLayoutGroupFragment, collection);
  const t1 = `collection.${slug}`;
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <LayoutGroup id={t1} {...props} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}